import React, { useRef } from 'react';
import { Avatar, Button, ButtonBase, FormControl, FormHelperText, Stack } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import FileActions from '../../Components/Common/Files/FileActions';
import { useTranslation } from '../../context/Internationalization';
import { colors } from '../../theme/colors';

export default function RegistrationPhotoField({ preview, selected, error, busy, onChange }) {
  const { t } = useTranslation();
  const input = useRef(null);
  const choosePhoto = () => input.current?.click();
  return <FormControl error={Boolean(error)}>
    <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap" useFlexGap>
      <ButtonBase type="button" onClick={choosePhoto} disabled={busy}
        aria-label={t('registration_upload_photo_action')} aria-describedby="registration-photo-hint"
        sx={{ borderRadius: '50%', '&.Mui-disabled': { opacity: .5 } }}>
        <Avatar src={preview || undefined} alt={t('registration_photo_preview')}
          sx={{ width: 48, height: 48, bgcolor: colors.Grey[100], color: colors.Grey[700] }}><AddIcon /></Avatar>
      </ButtonBase>
      <input ref={input} type="file" hidden disabled={busy} accept="image/png,image/jpeg,image/webp"
        aria-label={t('registration_upload_photo')}
        onChange={(event) => {
          if (event.target.files?.[0]) onChange(event.target.files[0]);
          event.target.value = '';
        }} />
      <Button variant="outlined" size="small" type="button" disabled={busy} onClick={choosePhoto}
        aria-invalid={Boolean(error)} aria-describedby="registration-photo-hint">{t('registration_upload_photo')}</Button>
      {preview && <FileActions file={{ url: preview, name: t('registration_photo_preview'), type: "image" }} />}
      {selected && <Button variant="text" size="small" type="button" disabled={busy} onClick={() => onChange(null)}>
        {t('registration_undo_photo')}
      </Button>}
    </Stack>
    <FormHelperText id="registration-photo-hint" role={error ? 'alert' : undefined} sx={{ mx: 0 }}>{t(error || 'registration_photo_hint')}</FormHelperText>
  </FormControl>;
}
